export class Region {
    name: string;
    regionId: string;
    id:string;
}